export default "/images/vendor/flag-icon-css/flags/4x3/sx.svg?37214364557e2b16b8d396bf93f1e5a7";